import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";

interface ConfirmModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: (updatedTitle: string) => void;
  title: string;
  body: string;
  templateTitle: string;
  actionType: "Create" | "Edit" | "Delete" | "Publish";
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  templateTitle,
  show,
  onHide,
  onConfirm,
  title,
  body,
  actionType,
}) => {
  const [localTemplateTitle, setLocalTemplateTitle] = useState<string>("");
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (actionType === "Edit") setLocalTemplateTitle(templateTitle);
    else if (actionType === "Create") setLocalTemplateTitle("");
    // For Publish/Delete we keep the title as-is (doesn't matter, we don't validate it)
    setError("");
  }, [templateTitle, actionType]);

  const handleConfirm = () => {
    if ((actionType === "Create" || actionType === "Edit") && !localTemplateTitle.trim()) {
      setError("Title is required.");
      return;
    }

    setError("");
    onConfirm(localTemplateTitle);
  };

  const showTitleField = actionType === "Create" || actionType === "Edit";

  return (
    <Modal show={show} onHide={onHide} backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* ✅ Always show the body message */}
        <div className="mb-2">{body}</div>

        {/* ✅ Show Title field only for Create/Edit */}
        {showTitleField && (
          <div className="row mt-2">
            <div className="col-md-12">
              <label>
                <strong>Title:</strong>
              </label>
              <input
                value={localTemplateTitle}
                onChange={(e) => setLocalTemplateTitle(e.target.value)}
                className={`form-control ${error ? "is-invalid" : ""}`}
              />
              {error && <div className="invalid-feedback">{error}</div>}
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>

        <Button
          variant={actionType === "Delete" ? "danger" : "primary"}
          onClick={handleConfirm}
        >
          {actionType === "Edit" ? "Save edit" : actionType}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
